export function initDragFinger() {
    const $fingerBlock = $('.finger-block');

    //уведомление для пальца на таблице
    $('body').on('pointerdown', '.finger-block', () => {
        $fingerBlock.remove();
    });

    $(window).on('scroll', function () {
        const scroll = $("html").scrollTop();
        const fingerPosition = $(".tabs-block.tournament-tables")?.offset()?.top || $('[data-pre-table]')?.offset()?.top;

        if (scroll > fingerPosition && !$fingerBlock.hasClass('offed')) {
            $fingerBlock.addClass('showed');
            $fingerBlock.addClass('animate');

            setTimeout(() => {
                $fingerBlock.removeClass('showed');
            }, 4000);

            setTimeout(() => {
                $fingerBlock.addClass('offed');
            }, 4500);
        }
    });
}